import { SHOWED_MODAL } from 'CoreComponents/modal/events';

const API_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
const CALLBACK_NAME = 'onJustSnapMeTurnstileReady';
const WIDGET_SELECTOR = '.cf-turnstile';

let turnstilePromise;

const loadTurnstile = () => {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }

  if (turnstilePromise) {
    return turnstilePromise;
  }

  turnstilePromise = new Promise((resolve, reject) => {
    window[CALLBACK_NAME] = () => {
      resolve(window.turnstile);
      delete window[CALLBACK_NAME];
    };

    const script = document.createElement('script');
    script.src = `${API_URL}?onload=${CALLBACK_NAME}&render=explicit`;
    script.async = true;
    script.defer = true;
    script.addEventListener('error', () => reject(new Error('Turnstile failed to load.')), { once: true });
    document.head.appendChild(script);
  });

  return turnstilePromise;
};

const renderTurnstile = (widget) => {
  if (widget.dataset.turnstileWidgetId) {
    return;
  }

  loadTurnstile().then((turnstile) => {
    if (widget.dataset.turnstileWidgetId) {
      return;
    }

    const widgetId = turnstile.render(widget, { sitekey: widget.dataset.sitekey });
    widget.dataset.turnstileWidgetId = widgetId;
  });
};

document.querySelectorAll(WIDGET_SELECTOR).forEach((widget) => {
  const modal = widget.closest('.modal');

  if (!modal) {
    renderTurnstile(widget);
    return;
  }

  document.querySelectorAll(`[data-toggle="modal"][data-target="#${modal.id}"]`).forEach((button) => {
    button.addEventListener('click', () => renderTurnstile(widget), { once: true });
  });

  modal.addEventListener(SHOWED_MODAL, () => renderTurnstile(widget));

  if (modal.classList.contains('modal--show')) {
    renderTurnstile(widget);
  }
});
